import { createColumnInput, createColumnSelect } from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import { createButtonCreate } from "../../../../../utils/button";
import { onClickDeleteAllClient } from '../../../../../utils/form';
import { createLoading } from '../../../../../utils/loading';
import { has } from "../../../../../utils/menu-context";
import { createManageDelete, createPage } from '../../../../../utils/page';
import lodash from 'lodash'
import { openModalList } from "./haz-license-detail.table";
import { callSpeciesByGroup } from "../../../master-mgt/haz-object/haz-object.section";
import store from "../../../../../store";
import moment from "moment";

export const { isLoading, setIsLoading } = createLoading()

export const createColumns = () => {
    const columns = [
        createColumnInput({ title: () => i18n.global.t("model.haz.approveCode"), dataIndex: "refHaz.approveCode",  align: "center" }),
        createColumnSelect({
            title: () => i18n.global.t("model.hazObject.refSpecies"),
            dataIndex: "refHaz.refHazObject.refSpecies.id",
            customRender: ({ record }) => <div>{record.refHaz?.refHazObject?.refSpecies?.value}</div>,
            inputProp: () => ({ list: callSpeciesByGroup, optLabel: "value" }),
            align: "center"
        }),
        createColumnInput({ title: () => i18n.global.t("model.hazObject.nameTh"), dataIndex: "refHaz.refHazObject.nameTh",  align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.hazObject.nameEn"), dataIndex: "refHaz.refHazObject.nameEn",  align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.haz.tradeNameTh"), dataIndex: "refHaz.tradeNameTh",  align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.haz.tradeNameEn"), dataIndex: "refHaz.tradeNameEn",  align: "center" }),
        createColumnInput({
            title: () => i18n.global.t("views.request.hazInfo.nature"),
            dataIndexValue: ({ record }) =>
                record.refHaz.isSolid  === true
                    ? record.refHaz.solid
                    : record.refHaz.liquid,
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            sorter: false,
            search: { visible: () => false }
        }),
        createColumnInput({ title: () => i18n.global.t("model.haz.manufacturer"), dataIndex: "refHaz.manufacturer",  align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.haz.refManufactureCountry"), dataIndex: "refHaz.refManufactureCountry.nameTh",  align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.haz.expireDate"), dataIndex: "refHaz.expireDate",  align: "center" }),
    ]
    return columns
}

export const initData = ({ props, data }) => {
    const { menuContext, viewOnly, itemsKey, visible, dataTempKey } = props
    const { useForm } = data
    const { modelRef } = useForm
    const dataModelRef = modelRef[dataTempKey]
    const items = itemsKey ? lodash.get(dataModelRef, itemsKey) : dataModelRef
    data.columns = createColumns({ props, data })
    data.page = createPage({ data: items })
    data.tableOptions = { search: { activeKey: null } }
    data.manages = [
        createManageDelete({
            menuContext,
            visible: () => viewOnly || [ "2", "3", "4" ].includes(modelRef.refRequestType?.key) && [ undefined, "draft" ].includes(modelRef.refStatus?.key) ? false : has({ menuContext, key: 'canDelete' }),
            onClick: ({ rowSelection }) => onClickDeleteAllClient({ rowSelection, useForm, items, key: itemsKey })
        }),
    ]
    data.manageExtras = []
    data.rowActions = []
    if (!viewOnly) {
        if (visible) {
            data.manageExtras.push({
                render: () => ({
                    ...createButtonCreate({
                        onClick: () => openModalList({
                            keyRequest: dataModelRef.refOperation?.key,
                            onIframeMounted: ({ refs, options }) => {
                                onIFrameClickSelectAll({
                                    refs, options, items, itemKey: 'refHaz.id', rowKey: 'id', setKey: 'refHaz', dataModelRef,
                                })
                            },
                        }),
                        options: { text: i18n.global.t('model.haz.modelName') }
                    }),
                }),
                visible: () => {
                    return has({ menuContext, key: 'canCreate' }) && [ undefined, "draft" ].includes(modelRef.refStatus?.key) && ![ "2", "3", "4" ].includes(modelRef.refRequestType?.key) && ("5" === dataModelRef.refOperation?.key || modelRef.refHazLicenseTemp.hazLicenseDetails.filter(res => !(res.isDelete === true)).length === 0 )
                },
            })
        }
    }
}

export const onIFrameClickSelectAll = ({ refs, options, items, itemKey, getKey, rowKey, setKey, onSearch, afterSelect, dataModelRef }) => {
    refs.iframe.contentWindow.onSearch = (param) => {
        const userInfo = store.state.resource.auth.info?.user;
        const page = param?.page;
        const defaultOnSearch = () => {
            const value = items.filter((d) => d.isDelete !== true).map((d) => lodash.get(d, itemKey));
            if (value.length > 0) {
                page.where.push({ name: rowKey, type: "UUID", operator: "!in", value });
            }
            if(["1","4"].includes(dataModelRef.refOperation?.key)) {
                page.where.push({ name: "refOperation.key", type: "String", operator: "=", value: dataModelRef.refOperation.key });
                page.where.push({ name: "refUserCompany.id", type: "UUID", operator: "=", value: dataModelRef.refUserCompany?.id ? dataModelRef.refUserCompany.id : userInfo.isEmployee ? userInfo.refParent.id : userInfo.id });
            }
            page.where.push({ name: "isActive", type: "Boolean", operator: "=", value: true });
            page.where.push({ name: "isTemp", type: "Boolean", operator: "=", value: false });
            page.where.push({ name: "effectiveDate", type: "Date", operator: "<=", value: moment().format("YYYY-MM-DD") });
            page.where.push({ name: "expireDate", type: "Date", operator: ">=", value: moment().format("YYYY-MM-DD") });
            page.where.push({ name: "refStatus.key", type: "String", operator: "=", value: "complete" });
            page.where.push({ name: "refHazObject.refSpecies.key", type: "String", operator: "=", value: dataModelRef.refSpecies.key });

            page.where.push({ openBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" });
            page.where.push({ name: "hazLicenseDetails.refHazLicense.refOperation.key", type: "String", operator: "=", value: null });
            if(["5"].includes(dataModelRef.refOperation?.key)) {
                page.where.push({ logic: "OR", openBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" });
            } else {
                page.where.push({ logic: "OR", openBucket: true, name: "hazLicenseDetails.refHazLicense.refOperation.key", type: "String", isNot:true, operator: "=", value: dataModelRef?.refOperation?.key });
            }
            page.where.push({
                closeBucket: true, type: 'Subquery', isNot:true, operator: 'exists', value: JSON.stringify({
                    clazz: 'HazLicense',
                    where: [
                        {
                            name: "hazLicenseDetails.refHaz.id", type: "GetpathParent", operator: "=", value: "id"
                        },
                        {
                            name: "refOperation.key", type: "String", operator: "=", value: dataModelRef.refOperation.key
                        },
                        {
                            name: "refUserCompany.id", type: "UUID", operator: "=", value: dataModelRef.refUserCompany?.id ? dataModelRef.refUserCompany.id : userInfo.isEmployee ? userInfo.refParent.id : userInfo.id
                        },
                        {
                            name: "refStatus.key", type: "String", isNot: true, operator: "=", value: "cancel"
                        },
                        {   openBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" },
                        {
                            openBucket: true, name: "expireDate", type: "Date", operator: ">=", value: moment().format("YYYY-MM-DD")
                        },
                        {
                            closeBucket: true, name: "isTemp", type: "Boolean", operator: "=", value: false
                        },
                        {
                            logic: 'OR',
                            openBucket: true, name: "expireDate", type: "Date", operator: "=", value: null
                        },
                        {
                            name: "refLastRequestTemp.refStatus.key", type: "String", isNot: true, operator: "in", value: ["approve", "notApprove", "cancel"]
                        },
                        {
                            closeBucket: true, name: "isTemp", type: "Boolean", operator: "=", value: true
                        },
                        {   closeBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" }
                        ]
                })
            })
            page.where.push({ logic: "OR", openBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" });
            page.where.push({ openBucket: true, name: "hazLicenseDetails.refHazLicense.refOperation.key", type: "String", operator: "=", value: dataModelRef.refOperation.key });
            page.where.push({
                closeBucket: true, type: 'Subquery', isNot:true, operator: 'exists', value: JSON.stringify({
                    clazz: 'HazLicense',
                    where: [
                        {
                            name: "hazLicenseDetails.refHaz.id", type: "GetpathParent", operator: "=", value: "id"
                        },
                        {
                            name: "refOperation.key", type: "String", operator: "=", value: dataModelRef.refOperation.key
                        },
                        {
                            name: "refUserCompany.id", type: "UUID", operator: "=", value: dataModelRef.refUserCompany?.id ? dataModelRef.refUserCompany.id : userInfo.isEmployee ? userInfo.refParent.id : userInfo.id
                        },
                        {
                            name: "refStatus.key", type: "String", isNot: true, operator: "=", value: "cancel"
                        },
                        {   openBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" },
                        {
                            openBucket: true, name: "expireDate", type: "Date", operator: ">=", value: moment().format("YYYY-MM-DD")
                        },
                        {
                            closeBucket: true, name: "isTemp", type: "Boolean", operator: "=", value: false
                        },
                        {
                            logic: 'OR',
                            openBucket: true, name: "expireDate", type: "Date", operator: "=", value: null
                        },
                        {
                            name: "refLastRequestTemp.refStatus.key", type: "String", isNot: true, operator: "in", value: ["approve", "notApprove", "cancel"]
                        },
                        {
                            closeBucket: true, name: "isTemp", type: "Boolean", operator: "=", value: true
                        },
                        {   closeBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" }
                    ]
                })
            })
            page.where.push({ openBucket: true, name: `refLastRequestHazLicenseOperation${dataModelRef.refOperation.key}.id`, type: "UUID", operator: "=", value: null });
            page.where.push({ closeBucket: true, logic: "OR", name: `refLastRequestHazLicenseOperation${dataModelRef.refOperation.key}.refStatus.key`, type: "String", operator: "in", value: ['approve', 'notApprove'] });
            page.where.push({ closeBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" });
            //page.where.push({ closeBucket: true, name: "hazLicenseDetails.refHazLicense.refLastRequestSameOperationTemp.refHazLicenseTemp.refStatus.key", type: "String", operator: "in", value: ['approve', 'notApprove'] });
            page.where.push({ closeBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" })
            page.isDistinct = true
        };
        if (onSearch) {
            onSearch(param);
        } else {
            defaultOnSearch();
        }
    };
    refs.iframe.contentWindow.onSelect = ({ rowSelection }) => {
        const itemsPush = [];
        rowSelection.selectedRows.forEach((row) => {
            const rowGet = getKey ? lodash.get(row, getKey) : row;
            let item = items.find((d) => lodash.get(d, itemKey) === lodash.get(row, rowKey));
            if (item) {
                item.isActive = true;
                item.isDelete = false;
                lodash.set(item, setKey, rowGet);
            } else {
                item = { isSave: true };
                if (setKey) {
                    lodash.set(item, setKey, rowGet);
                } else {
                    lodash.assign(item, rowGet);
                }
                itemsPush.push(item);
            }
        });
        items.push(...itemsPush);
        afterSelect?.({ rowSelection });
        options.bind.onCancel();
    };
};
